import { InstanceScreen } from 'component/navigation/instance';

export default function ModerationDashboardChannelsScreen() {
    return <InstanceScreen screenKey='channels' />;
}
